/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusResetPasswordDto } from '../../models/lexplus-reset-password-dto';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface AuthenticationControllerResetPasswordV1$Params {
      body: LexplusResetPasswordDto
}

export function authenticationControllerResetPasswordV1(http: HttpClient, rootUrl: string, params: AuthenticationControllerResetPasswordV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, authenticationControllerResetPasswordV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

authenticationControllerResetPasswordV1.PATH = '/v1/authentication/resetPassword';
